/**
 * Backend API Configuration
 */
const BACKEND_CONFIG = {
  // Backend API URL - defaults to localhost for development
  API_URL: process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:8000',
  
  // Timeout settings (in milliseconds)
  TIMEOUT: 60000, // 60 seconds
  
  // Retry settings
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second
};

export default BACKEND_CONFIG;
